import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={19}
            height={18}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.18 15.819h.533l.299-.568c.143-.272.21-.53.21-.782 0-.258-.07-.525-.22-.81l-.655-1.25h9.208V1.842a.346.346 0 00-.47-.319l-2.638.976-2.673-.976a.353.353 0 00-.246.001l-2.605.983-2.705-.984a.346.346 0 00-.468.32v11.59c0 1.318 1.088 2.387 2.43 2.387zm.695-10.227h2.777c.192 0 .347.152.347.34 0 .189-.155.342-.347.342H5.875a.344.344 0 01-.348-.341c0-.189.156-.341.348-.341zm5.555 2.726H5.875a.344.344 0 00-.348.341c0 .189.156.341.348.341h5.555a.344.344 0 00.347-.34.344.344 0 00-.347-.342zM17 14.794c0-.93-.759-1.687-1.702-1.704H6.223c.57.56.874 1.128.875 1.716.001.588-.301 1.148-.868 1.693h9.035c.958 0 1.735-.763 1.735-1.705z"
            fill={theme["#0D968F"]}
            opacity={0.5}
        />
        </svg>
    )
}
  
  export default SvgComponent